import { useEffect, useState, type ReactNode } from "react";
import { apiWebSocketUrl } from "../../../api/http/apiConfiguration";
import { reportEndedSession } from "../../../api/http/sessionCredentials";
import { readEntries } from "../../../api/threads/threadsApi";
import { ThreadLiveContext } from "./threadLiveContext";
import { ThreadLiveClient } from "./threadLiveClient";

/** One live client for the signed-in app; it connects only while a Thread is watched. */
export default function ThreadLiveProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new ThreadLiveClient({
        socketUrl: apiWebSocketUrl("/threads/live", window.location.href),
        readEntries: (threadId, after, limit) => readEntries(threadId, after, limit),
        onSessionEnded: reportEndedSession,
      }),
  );

  useEffect(() => {
    const retry = () => {
      client.retryNow();
    };
    window.addEventListener("online", retry);
    return () => {
      window.removeEventListener("online", retry);
    };
  }, [client]);

  useEffect(() => () => {
    client.dispose();
  }, [client]);

  return <ThreadLiveContext.Provider value={client}>{children}</ThreadLiveContext.Provider>;
}
